import i18n from 'i18n';

export enum StripeErrorCodes {
  CardDeclined = 'card_declined',
  ExpiredCard = 'expired_card',
}

export enum StripeDeclineCode {
  GenericDecline = 'generic_decline',
  InsufficientFunds = 'insufficient_funds',
  LostCard = 'lost_card',
  StolenCard = 'stolen_card',
}

export enum StripeStatusCode {
  RateLimit = 429,
}

export function getCustomErrorMessage(errorMessage?: string, errorCode?: string, statusCode?: number) {
  if (errorCode === StripeErrorCodes.CardDeclined) {
    return i18n.t('appointmentPayment.error.declined');
  }

  if (errorCode === StripeErrorCodes.ExpiredCard) {
    return i18n.t('appointmentPayment.error.expired');
  }

  if (statusCode === StripeStatusCode.RateLimit) {
    return i18n.t('appointmentPayment.error.rateLimit');
  }

  return errorMessage;
}

export function getIsDeclinedPayment(declineCode?: string, errorCode?: string) {
  return (
    Object.values(StripeDeclineCode).includes(declineCode as StripeDeclineCode) ||
    errorCode === StripeErrorCodes.ExpiredCard
  );
}
